export * from './message/constants';
export * from './chat/constants';
export * from './events/constants';
export * from './tasks/constants';
export var TEMPLATE_HEADER_TYPE;
(function (TEMPLATE_HEADER_TYPE) {
    TEMPLATE_HEADER_TYPE["TEXT"] = "TEXT";
    TEMPLATE_HEADER_TYPE["IMAGE"] = "IMAGE";
    TEMPLATE_HEADER_TYPE["VIDEO"] = "VIDEO";
    TEMPLATE_HEADER_TYPE["DOCUMENT"] = "DOCUMENT";
})(TEMPLATE_HEADER_TYPE || (TEMPLATE_HEADER_TYPE = {}));
export const BOT_SESSION_ACTIONS = {
    CREATE: 'CREATE',
    UPDATE: 'UPDATE',
    GET: 'GET',
};
export const BOT_SESSION_MESSAGE_ACTIONS = {
    UPDATE: 'UPDATE',
    GET: 'GET',
};
